(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var selector = '.bold-section-head, .bold-card, .bold-pick-card, .bold-equip-card, .bold-collhelp, .bold-branch, .bold-story__col';
  var els = document.querySelectorAll(selector);
  if (!els.length) return;

  var groups = {};
  els.forEach(function (el) {
    el.setAttribute('data-bold-reveal', '');
    var parent = el.parentElement;
    var key = parent ? parent.className : 'root';
    groups[key] = groups[key] || 0;
    var delay = Math.min(groups[key], 5) * 0.07;
    groups[key]++;
    el.style.transitionDelay = delay + 's';
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach(function (el) {
    io.observe(el);
  });
})();
